import React from "react";
import { useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import RightTick from "../../Assests/right-tick.svg";
import Loader from "./Loader";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function DoneDialogDuplicate(props: any) {
  const { uploadMasterFileMessage } = useSelector(
    (state: any) => state.InputDataReducers
  );

  return (
    <>
      <BootstrapDialog
        onClose={props.handleCloseDonePopup}
        aria-labelledby="customized-dialog-title"
        open={props.isOpenDone}
        className="done-modal"
      >
        <DialogContent className="done-modal-body" style={{marginLeft:30}}>
          <div>
            <img src={RightTick} alt="" className="right-tick" />
            <h2>Scenario Duplicated successfully!</h2>
            {/* <h3>Please Wait Module is in Process...</h3> */}
            <p>{props.donemessage}</p>
            <span>
              {uploadMasterFileMessage?.split(",").map((str: any, i: any) => {
                return <p key={i}>{str}</p>;
              })}
            </span>
            <p>Please Edit and click on Re-Run</p>
            <br></br>
            {/* <Loader /> */}
            <a onClick={props.handleCloseDonePopup}>Close</a>
          </div>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
}

export default DoneDialogDuplicate;
